<script setup lang="ts">
// Mount point of the whole cookie-consent UI (rendered once, from App.vue).
//
//   no valid decision  -> bottom banner
//   preferences open   -> modal with one toggle per category
//   decision on file   -> small floating button to reopen the preferences
import { onMounted } from 'vue'
import { useConsentStore } from '@/stores/consentStore'
import CookieBanner from './CookieBanner.vue'
import CookiePreferencesModal from './CookiePreferencesModal.vue'
import CookieSettingsButton from './CookieSettingsButton.vue'

const store = useConsentStore()

// A decision whose upload failed (offline, API down) is retried once per load; then the
// server is asked whether it still holds the decision, and if it says it does not (rows
// purged, a database reset) the banner comes back. In that order, so a decision that was
// just re-uploaded is not mistaken for a missing one.
onMounted(() => {
  void store.syncPending().then(() => store.verifyOnFile())
})
</script>

<template>
  <CookieBanner v-if="store.needsDecision && !store.preferencesOpen" />
  <CookiePreferencesModal v-if="store.preferencesOpen" />
  <CookieSettingsButton v-if="!store.needsDecision && !store.preferencesOpen" />
</template>
